import { schema } from "normalizr";

const CategorySchema = new schema.Entity("categories");
const CategoryArraySchema = new schema.Array(CategorySchema);

export { CategorySchema, CategoryArraySchema };